// District Calendar hints on scheduling forms: when a date (or date range) and its district are
// chosen, say which days the district is closed. The save itself is checked on the server.
//
// Mark the date field (an <input type="date">, or a wrapper around date_select's three selects) with
//   data-closed-hint="<id of the district source>"  a select of districts, or of contracts whose
//                                                   options carry data-lea-id
//   data-closed-hint-end="<id>"                     optional end date for a range
//   data-closed-hint-note="<id>"                    optional note element; otherwise the
//                                                   [data-closed-hint-note] in the same column
const pad = (n) => String(n).padStart(2, '0');

const dateOf = (el) => {
  if (!el) { return ''; }
  if (el.tagName === 'INPUT') { return el.value; }
  const part = (suffix) => el.querySelector(`select[id$="_${suffix}"]`);
  const [year, month, day] = ['1i', '2i', '3i'].map((s) => part(s) && part(s).value);
  return year && month && day ? `${year}-${pad(month)}-${pad(day)}` : '';
};

const leaOf = (source) => {
  if (!source) { return ''; }
  const option = source.options && source.options[source.selectedIndex];
  return (option && option.dataset.leaId) || source.value;
};

const noteFor = (el) => {
  if (el.dataset.closedHintNote) { return document.getElementById(el.dataset.closedHintNote); }
  const column = el.closest('[class*="col"]') || el.parentElement;
  return column.querySelector('[data-closed-hint-note]');
};

const refresh = (el) => {
  const note = noteFor(el);
  if (!note) { return; }
  const start = dateOf(el);
  const end = el.dataset.closedHintEnd ? dateOf(document.getElementById(el.dataset.closedHintEnd)) : start;
  const lea = leaOf(document.getElementById(el.dataset.closedHint));
  const show = (text) => { note.textContent = text; note.hidden = !text; };
  if (!start || !end || !lea || end < start) { show(''); return; }

  $.getJSON('/calendar_dates/closed.json', { lea_id: lea, start: start, end: end }, (days) => {
    if (!days.length) { show(''); return; }
    const list = days.map((d) => `${d.label} (${d.title})`).join(', ');
    show(start === end ? `The district is closed on ${list}.` : `The district is closed on ${list}; no sessions will be scheduled on those days.`);
  });
};

// Hints that depend on an element: the date fields themselves, their end dates and district sources
const hintsFor = (target) => Array.from(document.querySelectorAll('[data-closed-hint]')).filter((el) =>
  el === target || el.contains(target) || target.id === el.dataset.closedHint || target.id === el.dataset.closedHintEnd);

document.addEventListener('change', (event) => { hintsFor(event.target).forEach(refresh); });
document.addEventListener('turbolinks:load', () => { document.querySelectorAll('[data-closed-hint]').forEach(refresh); });
